import { render } from "./returnPoints.vue?vue&type=template&id=5d0d25a3&scoped=true"
import script from "./returnPoints.vue?vue&type=script&lang=js"
export * from "./returnPoints.vue?vue&type=script&lang=js"

import "./returnPoints.vue?vue&type=style&index=0&id=5d0d25a3&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0d25a3"]])

export default __exports__